import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {
    Button,
    Icon,
    Row,
    Form,
    Input,
    Col
} from 'antd';

const css = require('./index.scss');
const FormItem= Form.Item;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { getFieldDecorator } = this.props.form;
        const { editBank, companyInfo } = this.modulesState;
        return (
            <div className={`${css['company-contariner']}`}>
                <header>
                    <h2>账户信息</h2>
                    {
                        editBank ? (
                            <div className={css['company-contariner-hander']}>
                                <Button
                                    onClick={
                                        ()=> {
                                            this.updateDetailStatu(false);
                                        }
                                    }
                                >取消
                                </Button>
                                <Button 
                                    type="primary"
                                    onClick={
                                        () => {
                                            this.updateBank();
                                            this.updateDetailStatu(false);
                                        }
                                    }
                                >保存
                                </Button>
                                <Button 
                                    type="primary"
                                    icon="plus"
                                    onClick={this.addHandler}
                                />
                            </div>
                        ) : (
                            <Icon 
                                type="edit"
                                onClick={
                                    () => {
                                        this.updateDetailStatu(true);
                                    }
                                }
                            />
                        )
                    }
                </header>
                <Form layout="vertical" className={css['company-contariner-form']}>
                    <Row type="flex" justify="space-between">
                        <Col span={6}>
                            <FormItem label="开户行联行行号">
                                {
                                    editBank ? (
                                        getFieldDecorator('bankCode', {
                                            initialValue: companyInfo && companyInfo.bankCode
                                        })
                                        (<Input/>)
                                    ) : (<span>{companyInfo && companyInfo.bankCode}</span>)
                                }
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="企业账户开户行">
                                {
                                    editBank ? (
                                        getFieldDecorator('openingBank', {
                                            initialValue: companyInfo && companyInfo.openingBank
                                        })
                                        (<Input/>)
                                    ) : (<span>{companyInfo && companyInfo.openingBank}</span>)
                                }
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="企业账户账号">
                                {
                                    editBank ? (
                                        getFieldDecorator('bankId', {
                                            initialValue: companyInfo && companyInfo.bankId
                                        })
                                        (<Input/>)
                                    ) : (<span>{companyInfo && companyInfo.bankId}</span>)
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    {
                        (this.modulesState.openingBankInfos || []).map((item, index) => {
                            return (
                                <Row type="flex" justify="space-between" key={index}>
                                    <Col span={6}>
                                        {
                                            editBank ?
                                            <Icon 
                                                type="delete" 
                                                onClick={() => this.deleteHandler(index)}
                                            /> : ''

                                        }
                                    </Col>
                                    <Col span={6}>
                                        <FormItem label="企业账户开户行">
                                            {
                                                editBank ? (
                                                    <Input value={item.openingBank} onChange={(e) => this.onChangeInput(e, index, 'openingBank')}/>
                                                ) : (<span>{item.openingBank}</span>)
                                            }
                                        </FormItem>
                                    </Col>
                                    <Col span={6}>
                                        <FormItem label="企业账户账号">
                                            {
                                                editBank ? (
                                                    <Input value={item.bankId} onChange={(e) => this.onChangeInput(e, index, 'bankId')}/>
                                                ) : (<span>{item.bankId}</span>)
                                            }
                                        </FormItem>
                                    </Col>
                                </Row>
                            );
                        })
                    }
                </Form>
            </div>
        );
    }

    private updateDetailStatu = (b) => {
        ModulesAction.updateEditStatu('editBank', b);
    }
    private onChangeInput = (e, index, key) => {
        let arr = [...this.modulesState.openingBankInfos];
        arr[index][key] = e.target.value;
        this.modulesState.openingBankInfos = arr;
        this.setModulesState();
    }
    private addHandler = () => {
        let arr = [...this.modulesState.openingBankInfos];
        arr.push({
            openingBank: '',
            bankId: ''
        });
        this.modulesState.openingBankInfos = arr;
        this.setModulesState();
    }
    private deleteHandler = (index) => {
        let arr = [...this.modulesState.openingBankInfos];
        arr.splice(index, 1);
        this.modulesState.openingBankInfos = arr;
        this.setModulesState();
    }

    private updateBank = () => {
        this.props.form.validateFields((err, val)=>{
            if (!err) {
                ModulesAction.bankUpdate(val);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/UI.Bank.tsx